import { Flex, styled } from '@withjoy/joykit';

export const StyledStartContainer = styled(Flex)<{ scrollToElementId?: string }>`
  align-items: center;
  cursor: ${props => (props.scrollToElementId ? 'pointer' : 'default')};
  &:hover svg stop:first-child {
    stop-color: ${props => props.theme.colors.mono12};
  }
  &:hover svg stop:last-child {
    stop-color: ${props => props.theme.colors.mono3};
  }
  &:active svg stop:first-child {
    stop-color: ${props => props.theme.colors.mono13};
  }
  &:active svg stop:last-child {
    stop-color: ${props => props.theme.colors.mono4};
  }
`;
